// 西班牙语（西班牙）
export default {
  company: {
    deviceList: 'Lista de dispositivos',
    name: 'TIME PHOTO',
    desc: '¡Disfruta del maravilloso momento!',
    companyName: 'Nombre del comerciante',
    companyInfo: 'Información del comerciante',
    linkMan: 'Persona de contacto',
    contactInfo: 'Información de contacto',
    cooperationWay: 'Modo de cooperación',
    jointOperation: 'Operación conjunta',
    selfOperated: 'Operación propia',
    agent: 'Agente',
    businessStatus: 'Estado del negocio',
    operating: 'En funcionamiento',
    stopped: 'Cerrado',
    hasBackend: 'Backend habilitado',
    backendAccount: 'Cuenta de backend',
    backendPassword: 'Contraseña de backend',
    deviceCount: 'Número de máquinas',
    orderData: 'Datos de pedidos',
    companyRatio: 'Ratio del comerciante (%)',
    operatorRatio: 'Ratio del operador (%)',
    companyDesc: 'Descripción del comerciante',
    companyAddress: 'Dirección del comerciante',
    openAggregatedPay: 'Pago agregado habilitado',
    thirdPayWay: 'Método de pago de terceros',
    merchantId: 'ID del comerciante',
    merchantType: 'Tipo de comerciante',
    merchantAppid: 'Appid del comerciante',
    wechatRedirectUrl: 'URL de redirección de pago de WeChat',
    payNotifyUrl: 'URL de devolución de llamada de pago',
    refundNotifyUrl: 'URL de devolución de llamada de reembolso',
    sqbMerchantCode: 'Código del comerciante (Shouqianba)',
    sqbDeveloperKey: 'Clave de desarrollador de Shouqianba',
    storeActiveCode: 'Código de activación de tienda',
    frontendCallbackUrl: 'URL de devolución de llamada del frontend',
    merchantSecret: 'Secret del comerciante',
    unit: 'unidades',
    merchantLevel: 'Nivel del comerciante',
    level2Merchant: 'Comerciante de nivel 2',
    level3Merchant: 'Comerciante de nivel 3',
    aggregatedPayMerchant: 'Comerciante de pago agregado',
    backendOpen: 'Backend abierto',
    forwardIncomingPrefix: 'Huilaimi Entrada_',
    qrCodeGenerateFailed: 'Error al generar el código QR, inténtelo de nuevo',
    invalidWebUrl: 'URL web obtenida no válida, contacte al administrador',
    noValidWebUrl: 'No se obtuvo una URL web válida',
    fetchDataFailed: 'Error al obtener los datos, inténtelo de nuevo',
    browserNotSupportDownload: 'Su navegador no admite descarga automática, haga clic derecho para guardar la imagen',
    downloadImageFailed: 'Error al descargar la imagen, inténtelo de nuevo',
    httpError: 'Error HTTP, código de estado: {status}',
    copyCompanyName: 'Copiar nombre del comerciante',
    copySuccess: 'Copiado con éxito',
    copyFail: 'Error al copiar'
  },
  income: {
    totalIncome: 'Importe total de pedidos',
    platformIncome: 'Participación de la plataforma',
    companyIncome: 'Ingresos del sistema de comerciantes',
    subMerchantIncome: 'Parte del subcomerciante',
    parentIncome: 'Retención del comerciante superior',
    orderCount: 'Número de pedidos',
    subMerchantIncomeDetail: 'Detalle de ingresos de subcomerciantes',
    subRatioText: 'Retención de nivel tres',
    subJustRatioText: 'Comisión de nivel dos',
    splitRatio: 'Ratio de reparto',
    deviceCount: 'Número de dispositivos',
    deviceCode: 'Código del dispositivo',
    deviceName: 'Nombre del dispositivo'
  },
  login: {
    username: 'Nombre de usuario',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    inputUsername: 'Por favor ingrese el nombre de usuario',
    inputPassword: 'Por favor ingrese la contraseña'
  },
  employee: {
    inputAccount: 'Por favor ingrese la cuenta',
    inputName: 'Por favor ingrese el nombre',
    inputMobile: 'Por favor ingrese el número de móvil',
    selectRole: 'Por favor seleccione el rol',
    allRoles: 'Todos los roles',
    allStatus: 'Todos los estados',
    collapse: 'Contraer',
    expand: 'Expandir',
    employeeCount: 'Número de empleados: ',
    addEmployee: '+ Agregar empleado',
    account: 'Cuenta',
    name: 'Nombre',
    gender: 'Género',
    role: 'Rol',
    company: 'Empresa perteneciente',
    creator: 'Agregado por',
    createTime: 'Fecha de agregado',
    devicePermission: 'Permiso de dispositivo',
    deviceCountUnit: '{count} dispositivo(s)',
    viewAllDevices: 'Ver todos los dispositivos',
    disableAccount: 'Desactivar',
    resetPassword: 'Restablecer contraseña',
    assignDevices: 'Asignar dispositivos',
    tip: 'Aviso',
    deleteConfirm: 'Después de eliminar la cuenta, ya no podrá iniciar sesión en el sistema. ¿Confirmar eliminación?',
    employeeName: 'Nombre del empleado: ',
    usernameLabel: 'Nombre de usuario: ',
    currentPermission: 'Permiso actual: ',
    assignedDevices: '{count} dispositivo(s) asignado(s)',
    selectDevice: 'Seleccionar dispositivos: ',
    selectDevicePlaceholder: 'Por favor seleccione dispositivos',
    deviceHint: 'No seleccionar ningún dispositivo significa que el empleado puede ver todos los dispositivos de la empresa',
    selectAtLeastOneDevice: 'Por favor seleccione al menos 1 dispositivo',
    assignSuccess: 'Dispositivos asignados correctamente',
    assignFailed: 'Error al asignar',
    loadDeviceInfoFailed: 'Error al cargar la información del dispositivo',
    loadDeviceListFailed: 'Error al cargar la lista de dispositivos',
    disableConfirmTitle: '¿Está seguro de desactivar esta cuenta de empleado?',
    disableConfirmContent: 'Después de desactivar, el empleado no podrá iniciar sesión',
    disableSuccess: 'Desactivado correctamente',
    enableConfirmTitle: '¿Está seguro de activar esta cuenta de empleado?',
    enableConfirmContent: 'Después de activar, el empleado podrá iniciar sesión',
    enableSuccess: 'Activado correctamente',
    resetPwdConfirmTitle: '¿Está seguro de restablecer la contraseña de este empleado?',
    resetPwdConfirmContent: 'Después de restablecer, la contraseña volverá a la contraseña predeterminada (JTphoto0515)',
    resetPwdSuccess: 'Contraseña restablecida correctamente',
    addSuccess: 'Empleado agregado correctamente',
    updateSuccess: 'Empleado modificado correctamente',
    addTitle: 'Agregar empleado',
    editTitle: 'Modificar empleado',
    accountLabel: 'Cuenta:',
    nameLabel: 'Nombre:',
    passwordLabel: 'Contraseña:',
    defaultPwdTip: 'Déjelo en blanco para usar la contraseña predeterminada JTphoto0515',
    defaultPwdPlaceholder: 'Dejar en blanco para usar la contraseña predeterminada',
    emailLabel: 'Correo electrónico:',
    emailInvalid: 'Por favor ingrese un correo electrónico válido',
    maxLength50: 'La longitud no puede superar los 50 caracteres',
    mobileLabel: 'Móvil:',
    mobileInvalid: 'Por favor ingrese un número de móvil válido',
    roleSetting: 'Rol:',
    statusSetting: 'Estado:',
    selectStatus: 'Por favor seleccione el estado',
    genderSetting: 'Género:',
    selectGender: 'Por favor seleccione el género',
    deptSetting: 'Departamento:',
    remarkLabel: 'Observación:',
    remarkPlaceholder: 'Por favor ingrese la observación',
    submit: 'Enviar',
    save: 'Guardar',
    usernameRequired: 'El nombre de usuario no puede estar vacío',
    usernameMax20: 'El nombre de usuario no puede superar los 20 caracteres',
    usernameMin4: 'El nombre de usuario no puede tener menos de 4 caracteres',
    usernameExists: 'Lo sentimos, este nombre de usuario ya existe',
    mobileRequired: '¡El número de móvil no puede estar vacío!',
    nameRequired: '¡El nombre no puede estar vacío!',
    roleRequired: '¡El rol no puede estar vacío!'
  },
  homepage: {
    totalIP: 'IP total',
    todayfc: 'Ingresos de hoy',
    weekQOQ: 'Comparación semanal',
    dayQOQ: 'Comparación diaria',
    todayCompanyIncome: 'Ingresos del comerciante hoy',
    todayPlatformIncome: 'Ingresos de la plataforma hoy',
    todayFlow: 'Flujo de clientes hoy',
    todayOrder: 'Pedidos hoy',
    todayRefundOrder: 'Pedidos de reembolso hoy',
    machineOnlineCount: 'Máquinas en línea',
    machineOfflineCount: 'Máquinas fuera de línea',
    totalPlatformIncome: 'Ingresos totales de la plataforma',
    totalOperatorIncome: 'Comisión total del operador',
    totalCompanyIncome: 'Ingresos totales del comerciante',
    totalFlow: 'Flujo total de clientes',
    totalOrder: 'Total de pedidos',
    totalRefundOrder: 'Total de reembolsos',
    usage: 'Uso',
    incomeAmount: 'Monto de ingresos',
    flow: 'Flujo',
    orderCount: 'Número de pedidos',
    todayIncome: 'Ingresos de hoy',
    lastLoginTime: 'Último inicio de sesión',
    canWithdrawalIncome: 'Ingresos retirables',
    goodMorning: 'Buenos días',
    goodForenoon: 'Buen día',
    goodNoon: 'Buen mediodía',
    goodAfternoon: 'Buenas tardes',
    goodEvening: 'Buenas noches',
    welcome1: 'Tómate un café y descansa ☕',
    welcome2: '¿Quieres jugar LOL con amigos?',
    welcome3: '¿Quieres jugar Honor of Kings con amigos?',
    welcome4: 'Te ves aún mejor después de unos días 😍',
    welcome5: '¿Cuántos bugs escribiste hoy 🐞?',
    welcome6: '¿Chateaste en el grupo hoy?',
    welcome7: '¿Qué comida deliciosa comiste hoy?',
    welcome8: '¿Sonreíste hoy 😊?',
    welcome9: '¿Ayudaste a otros a resolver problemas hoy?',
    welcome10: '¿Qué vas a comer?',
    welcome11: '¿Ir al cine este fin de semana?',
    dateRange: '{start}~{end}',
    withdraw: 'Retirar',
    avatarAlt: 'Avatar',
    noDept: 'Sin departamento',
    noRole: 'Sin rol',
    firstVisit: 'Primera visita',
    todayIp: 'IP de hoy',
    todayVisit: 'Visitas de hoy',
    totalVisit: 'Visitas totales',
    lowPaperTitle: 'Aviso de papel fotográfico insuficiente',
    lowPaperTip: 'Los siguientes dispositivos tienen menos de {count} hojas de papel fotográfico. ¡Reponga el papel a tiempo para no afectar el uso normal!',
    lowPaperDeviceName: 'Nombre del dispositivo',
    lowPaperDeviceCode: 'Código del dispositivo',
    lowPaperCount: 'Cantidad de papel',
    lowPaperClose: 'Cerrar'
  },
  device: {
    companyManage: 'Gestión de comerciantes',
    deviceManage: 'Gestión de dispositivos',
    totalDevices: 'Total de máquinas',
    all: 'Todos',
    online: 'En línea',
    offline: 'Fuera de línea',
    updating: 'Actualizando',
    versionUpdate: 'Actualización de versión',
    export: 'Exportar',
    batchUpdate: 'Actualización por lotes',
    unbind: 'Desvincular',
    bind: 'Vincular',
    companyName: 'Nombre del comerciante',
    deviceCode: 'Código del dispositivo',
    appVersion: 'Versión de la aplicación',
    sn: 'Número de serie',
    uiName: 'Nombre de UI',
    uiGroupName: 'Grupo de UI',
    photoTime: 'Tiempo de foto',
    intervalTime: 'Intervalo de tiempo',
    pagerNum: 'Número de páginas',
    goodsNum: 'Número de productos',
    filterNum: 'Número de filtros',
    address: 'Dirección de la máquina',
    orderCount: 'Número de pedidos',
    operation: 'Operación',
    command: 'El comando se ha enviado correctamente',
    reset: 'Reiniciar',
    restartApp: 'Reiniciar aplicación',
    showMenu: 'Mostrar menú',
    hideMenu: 'Ocultar menú',
    reportLog: 'Reportar registro',
    isSupperCoins: 'Soporte para monedas',
    unbinded: 'Desvinculado',
    binded: 'Vinculado',
    bindStatus: 'Estado de vinculación',
    lastestOnlineTime: 'Última vez en línea',
    macAddress: 'Dirección MAC',
    resolution: 'Resolución',
    deviceSN: 'SN del dispositivo',
    deviceVersion: 'Versión del dispositivo',
    deviceKey: 'Clave del dispositivo',
    deviceIMEI: 'IMEI del dispositivo',
    activationCode: 'Código de activación',
    leyaoyaoCode: 'Código Leyaoyao',
    electronicPhoto: 'Foto electrónica',
    scanDownload: 'Escanear para descargar',
    sendFriend: 'Enviar a amigo',
    templateImage: 'Imagen de plantilla',
    working: 'Trabajando',
    workStatus: 'Estado de trabajo',
    thumbnail: 'Miniatura',
    remoteCode: 'Código remoto',
    belongCategory: 'Categoría',
    allMerchants: 'Todos los comerciantes',
    assign: 'Asignar',
    viewOrders: 'Ver pedidos',
    selectBindMerchant: 'Por favor seleccione el comerciante a vincular',
    pendingVendorActive: 'Activación de Shouqianba pendiente',
    vendorActivationCode: 'Código de activación de Shouqianba',
    vendorActivationCodePlaceholder: 'Introduzca el código de activación de Shouqianba',
    vendorActivationCodeRequired: 'Por favor introduzca el código de activación de Shouqianba',
    merchantName: 'Nombre del comerciante',
    selectMerchantName: 'Por favor seleccione el nombre del comerciante',
    assignDeviceToSub: 'Asignar dispositivo a subcomerciante',
    deviceLabel: 'Dispositivo: ',
    targetMerchant: 'Comerciante de destino',
    selectSubMerchant: 'Por favor seleccione un subcomerciante',
    noSubMerchant: 'No hay subcomerciantes disponibles, cree primero un comerciante de nivel 3',
    selectTargetMerchant: 'Por favor seleccione un comerciante de destino',
    assignSuccess: 'Dispositivo asignado correctamente',
    assignFailed: 'Error al asignar el dispositivo',
    selectDeviceToUpdate: '¡Seleccione los dispositivos a actualizar! Al menos uno',
    setupSuccess: 'Configuración del dispositivo exitosa',
    updateUI: 'Actualizar UI',
    updateApp: 'Actualizar APP',
    updateConfig: 'Actualizar configuración',
    shellExec: 'Ejecución de comandos Shell',
    shellCommand: 'Comando Shell',
    shellCommandPlaceholder: 'Ingrese el comando Shell a ejecutar, ej.: ls -la /tmp',
    sendShellCommand: 'Enviar comando Shell',
    dangerousConfirmTip: 'Los comandos peligrosos requieren confirmación',
    notifiedUpdateUI: 'Dispositivo notificado para actualizar UI',
    notifiedUpdateApp: 'Dispositivo notificado para actualizar APP',
    notifiedUpdateConfig: 'Dispositivo notificado para actualizar la configuración',
    inputShellCommand: 'Por favor ingrese un comando Shell',
    dangerousWarningTitle: '⚠️ Advertencia de operación peligrosa',
    dangerousWarningContent: '¡Está ejecutando un comando peligroso que puede causar anomalías en el dispositivo! ¿Desea continuar?',
    confirmExecute: 'Confirmar ejecución',
    commandSent: 'Comando enviado, espere a que el dispositivo lo ejecute',
    sendFailed: 'Error al enviar',
    networkError: 'Error de red, inténtelo de nuevo más tarde',
    confirmUnbind: 'Después de desvincular, el dispositivo se desasociará del comerciante. ¿Está seguro de que desea desvincular este dispositivo?',
    copyCompanyName: 'Copiar nombre del comerciante',
    copyDeviceCode: 'Copiar código del dispositivo',
    copyActiveCode: 'Copiar código de activación',
    copySuccess: 'Copiado con éxito',
    copyFail: 'Error al copiar'
  },
  setting: {
    navbarColor: 'Color de la barra de navegación',
    themeColor: 'Color del tema',
    navbarPosition: 'Posición de la barra de navegación',
    fixedTopRail: 'Fijar barra superior',
    fixedSidebar: 'Fijar barra lateral',
    multiTabMode: 'Modo multi-pestaña',
    languageSwitching: 'Cambiar idioma',
    userCenter: 'Centro de usuario',
    updatePassword: 'Actualizar contraseña',
    customSystem: 'Personalizar sistema',
    logout: 'Cerrar sesión',
    updateCache: 'Actualizar caché',
    refreshCacheSuccess: 'Caché actualizada exitosamente',
    refreshCacheFailed: 'Error al actualizar la caché'
  },
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    saveSetting: 'Guardar configuración',
    languageChanged: 'Idioma cambiado exitosamente',
    timezoneChanged: 'Zona horaria cambiada exitosamente',
    search: 'Buscar',
    pleaseInputContent: 'Por favor ingrese el contenido',
    export: 'Exportar',
    default: 'Predeterminado',
    item: 'Elemento',
    view: 'Ver',
    setup: 'Configuración',
    status: 'Estado',
    showTotal: 'Mostrando {start} ~ {end} registros, total {total} registros',
    yes: 'Sí',
    no: 'No',
    info: 'Información',
    sequenceNumber: 'Nº',
    creationTime: 'Fecha de creación',
    operation: 'Operación',
    defaultSort: 'Número de orden',
    type: 'Integrado',
    edit: 'Editar',
    delete: 'Eliminar',
    deleteSuccess: 'Eliminado exitosamente',
    editSuccess: 'Editado exitosamente',
    updateSuccess: 'Actualizado exitosamente',
    connectionError: 'Conexión al servidor anormal, ¡intente nuevamente más tarde!',
    reset: 'Restablecer',
    allCategory: 'Todas las categorías',
    query: 'Consulta',
    add: 'Agregar',
    loadError: 'Error de carga',
    isDefault: 'Predeterminado',
    setDefault: 'Establecer como predeterminado',
    cancelDefault: 'Cancelar predeterminado',
    batchEdit: 'Edición por lotes',
    back: 'Volver',
    uploadImg: 'Subir imagen',
    uploadImgSuccess: 'Imagen subida exitosamente',
    uploadImgFailed: 'Error al subir',
    uploadImgTips1: 'Solo se permiten formatos JPG, JPEG, GIF, PNG',
    uploadImgTips2: 'El archivo excede el límite de 10M, no se permite subir',
    addSuccess: 'Añadido con éxito',
    all: 'Todo',
    batchAdd: 'Agregar por lotes',
    deleteError: 'Error al eliminar',
    deleteNoData: 'Seleccione los datos a eliminar',
    disable: 'Desactivado',
    enable: 'Activado',
    exportError: '¡Exportación fallida!',
    exportExecl: 'Exportar Excel',
    exportSuccess: 'Exportación exitosa',
    noData: 'Sin datos',
    operateError: 'Operación fallida, inténtelo de nuevo',
    prompt: 'Consejos',
    searchError: 'Error en la búsqueda',
    selectDataFirst: '¡Seleccione primero las pegatinas a exportar!',
    uploadError: 'Error al subir',
    selectAll: 'Seleccionar todo',
    totalRecords: '{total} registros en total',
    closeLeft: 'Cerrar izquierda',
    closeRight: 'Cerrar derecha',
    closeOthers: 'Cerrar otros'
  },
  template: {
    merchantManagement: 'Comerciante',
    uiManagement: 'UI',
    newConfig: 'Nuevo marco',
    editFrame: 'Editar marco',
    editConfig: 'Editar configuración',
    top: 'Superior',
    bottom: 'Inferior',
    builtIn: 'Integrado',
    nonBuiltIn: 'No integrado',
    uiConfigName: 'Nombre',
    background: 'Fondo',
    wechatOfficialAccount: 'Código QR',
    title: 'Título',
    banner: 'Banner',
    creationTime: 'Fecha de creación',
    indicatorColor: 'Color del indicador',
    type: 'Tipo',
    appliedMachines: 'Máquinas aplicadas',
    freamName: 'Nombre del marco',
    editSuccess: 'UI editada exitosamente',
    tip: 'Consejo',
    deletePrompt: 'Eliminar esta configuración de UI impedirá que el usuario la use. ¿Está seguro de que desea eliminarla?',
    matchProduct: 'Coincidir producto',
    selectProduct: 'Por favor seleccione un producto',
    templateFilePng: 'Archivo de plantilla PNG',
    maxFileSize: 'El tamaño máximo del archivo es 10M ',
    addUploadImage: 'Agregar imagen subida',
    addHistoryImage: 'Seleccionar imagen histórica',
    previewImage: 'Vista previa',
    cuttingImage: 'Imagen de recorte',
    groupPhotoFrame: 'Marco de foto grupal',
    groupPhotoYes: 'Foto grupal',
    groupPhotoNo: 'No foto grupal',
    groupPhotoLensSetting: 'Configurar detalle de lente grupal',
    groupPhotoConfigured: 'Foto grupal configurada',
    groupPhotoNotSet: 'Foto grupal no configurada',
    buttonNormal: 'Botón normal',
    buttonPressed: 'Botón presionado',
    buttonNormalExample: 'Ejemplo de botón normal',
    buttonPressedExample: 'Ejemplo de botón presionado',
    reuseTemplateFile: 'Reutilizar archivo de plantilla',
    reuseNormalButton: 'Reutilizar botón normal',
    reuseAllTemplateFiles: 'Reutilizar todos los archivos de plantilla',
    productType: 'Tipo de producto',
    stickerPreview: 'Vista previa de pegatina',
    stickerCode: 'Código de pegatina',
    stickerCategory: 'Categoría',
    stickerType: 'Tipo',
    stickerSize: 'Tamaño',
    stickerStatus: 'Estado',
    stickerOperation: 'Operación',
    stickerName: 'Nombre de pegatina',
    addSticker: 'Agregar pegatina',
    editSticker: 'Editar pegatina',
    StickerIndexNum: 'Número de orden',
    onlyImage: 'Solo se pueden subir imágenes JPG, JPEG, GIF y PNG',
    selectCategory: 'Seleccione una categoría',
    selectStatus: 'Seleccione el estado',
    selectType: 'Seleccione el tipo',
    stickerFileSize: 'Tamaño del archivo',
    staticSticker: 'Pegatina estática',
    gifSticker: 'Animación GIF',
    videoSticker: 'Pegatina de video',
    frameGroup: 'Grupo de marcos'
  },
  sticker: {
    stickerPreview: 'Imagen de pegatina',
    stickerCode: 'Código de pegatina',
    stickerCategory: 'Categoría',
    stickerType: 'Tipo',
    stickerSize: 'Tamaño',
    stickerStatus: 'Estado',
    stickerOperation: 'Operación',
    stickerName: 'Nombre de pegatina',
    stickerImage: 'Imagen de pegatina',
    stickerThumbnail: 'Miniatura',
    stickerWidth: 'Ancho (píxeles)',
    stickerHeight: 'Alto (píxeles)',
    stickerDuration: 'Duración del archivo (segundos)',
    stickerFileSize: 'Tamaño del archivo',
    StickerIndexNum: 'Número de orden',
    stickerTags: 'Palabras clave',
    stickerDescription: 'Descripción',
    statusTips: 'Por favor seleccione el estado',
    typeTips: 'Por favor seleccione el tipo',
    categoryTips: 'Por favor seleccione la categoría',
    editSticker: 'Editar pegatina',
    imgPreview: 'Vista previa de imagen',
    codeCheckResultErr: '❌ Este código ya existe, por favor cámbielo',
    codeCheckResultOk: '✅ Código disponible',
    inputCodeTips: 'Opcional. Los dispositivos distinguen el tipo de pegatina por el sufijo del código (ej.: ST2D). Se recomiendan mayúsculas, dígitos y guiones bajos',
    addSticker: 'Agregar pegatina',
    categoryIcon: 'Icono de categoría',
    categoryName: 'Nombre de categoría',
    categoryCode: 'Código de categoría',
    categoryIconPlaceholder: 'Por favor ingrese la URL del icono',
    addCategory: 'Agregar categoría',
    editCategory: 'Editar categoría',
    groupNewAdd: 'Nuevo grupo',
    groupEdit: 'Editar grupo',
    groupName: 'Nombre del grupo',
    groupCode: 'Código del grupo',
    groupIcon: 'Icono del grupo',
    hasSticker: 'Número de pegatinas',
    groupCodePlaceholder: 'Por favor ingrese el código del grupo (letras mayúsculas)',
    groupNamePlaceholder: 'Por favor ingrese el nombre del grupo',
    groupDescriptionPHR: 'Por favor ingrese la descripción del grupo',
    controllerSticker: 'Gestionar pegatinas',
    selectSticker: 'Seleccionar pegatina',
    addFailed: 'Error al agregar',
    addSuccess: 'Añadido con éxito',
    deleteFailed: 'Error al eliminar',
    deleteSuccess: 'Eliminado con éxito',
    fileDurationDesc: 'Solo para video/GIF, opcional',
    fileDurationTips: 'Solo requerido para pegatinas de video/GIF',
    fileSizeDesc: 'Se completa automáticamente después de subir',
    fileSizeExample: 'ej.: 51200',
    heightExample: 'ej.: 200',
    widthExample: 'ej.: 200',
    selectAtLeastOne: 'Seleccione al menos una pegatina',
    stickerCodeDesc: 'Identificador único global, se recomienda el formato STICKER_XXX',
    stickerCodeTips: 'Ingrese el código de la pegatina (único)',
    stickerImageSize: 'Tamaño recomendado: 200x200 píxeles, admite formatos PNG, JPG',
    thumbnail: 'Miniatura',
    uploadStickerImage: 'Suba la imagen de la pegatina',
    confirmDeleteSticker: '¿Está seguro de eliminar esta pegatina?',
    stickerSlected: 'Pegatinas seleccionadas',
    inputStickerName: 'Por favor ingrese el nombre de la pegatina',
    inputStickerCode: 'Por favor ingrese el código de la pegatina',
    codeFormatTips: 'Se recomienda el formato STICKER_XXX',
    codeExists: 'Este código de pegatina ya existe, por favor cámbielo',
    codeValidateFailed: 'Validación fallida',
    codeValidateError: 'Error al validar el código, inténtelo de nuevo',
    codeFormatError: 'Formato de código inválido, se recomienda el formato STICKER_XXX',
    codeCheckFailedRetry: 'Validación fallida, inténtelo de nuevo',
    tagsPlaceholder: 'Separe varias etiquetas con comas, ej.: feliz, emoji, sonrisa',
    tagsDesc: 'Usado para búsqueda y categorización',
    descPlaceholder: 'Por favor ingrese la descripción de la pegatina',
    uploadImage: 'Subir imagen',
    uploadThumbnail: 'Subir miniatura',
    reuseStickerImage: 'Reutilizar imagen del sticker',
    reuseStickerImageTip: 'La miniatura usará directamente la imagen del sticker, no se necesita subida aparte',
    thumbnailOptional: 'Opcional, el sistema puede generarla automáticamente',
    thumbnailUploadSuccess: 'Miniatura subida con éxito',
    selectCategoryAttr: 'Por favor seleccione una categoría',
    completeFormInfo: 'Por favor complete los campos obligatorios del formulario',
    sortOrderPlaceholder: 'Cuanto menor sea el número, más arriba',
    categoryCodePlaceholder: 'Por favor ingrese el código de categoría (mayúsculas)',
    categoryCodeDesc: 'Identificador único, se recomiendan mayúsculas, ej.: HOT, CUTE',
    inputCategoryName: 'Por favor ingrese el nombre de la categoría',
    inputCategoryCode: 'Por favor ingrese el código de categoría',
    categoryCodePatternMsg: 'Por favor ingrese mayúsculas, puede contener guiones bajos',
    categoryCodeExists: 'Este código de categoría ya existe, por favor cámbielo',
    uploadCategoryIcon: 'Por favor suba el icono de categoría',
    sortOrderMustNumber: 'El número de orden debe ser un número',
    categoryDescPlaceholder: 'Por favor ingrese la descripción de la categoría',
    confirmDeleteCategory: '¿Confirmar la eliminación de esta categoría?',
    exportDeveloping: 'La función de exportación está en desarrollo...',
    confirmDeleteGroup: '¿Está seguro de eliminar este grupo?',
    selectGroupToDelete: 'Por favor seleccione el grupo a eliminar',
    inputGroupName: 'Por favor ingrese el nombre del grupo',
    groupNameTooLong: 'El nombre del grupo no puede exceder 50 caracteres',
    inputGroupCode: 'Por favor ingrese el código del grupo',
    groupCodeFormatMsg: 'El código del grupo solo puede contener mayúsculas, números y guiones bajos',
    groupCodeTooLong: 'El código del grupo no puede exceder 50 caracteres',
    groupCodeInvalidOrExists: 'El formato del código del grupo es inválido o ya existe, por favor verifique',
    uploadGroupIcon: 'Por favor suba el icono del grupo',
    sortOrderInvalid: 'Por favor ingrese un número de orden válido (número >= 0)',
    selectStatusEnableDisable: 'Por favor seleccione el estado (Activado/Desactivado)',
    codeCheckErrorTips: '⚠️ Validación del código fallida, inténtelo más tarde',
    editFailed: 'Error al editar',
    operationFailedRetry: 'Operación fallida, inténtelo de nuevo',
    apiException: 'Error del sistema',
    selectStickerType: 'Por favor seleccione el tipo de pegatina'
  },
  filter: {
    filterName: 'Nombre del filtro',
    addFilter: '+ Añadir filtro',
    addFilterTitle: 'Añadir filtro',
    editFilterTitle: 'Editar filtro',
    filterPreview: 'Vista previa del filtro',
    filterOriginalImage: 'Imagen original del filtro',
    filterResourceFile: 'Archivo de recursos del filtro',
    belongCompany: 'Comercio',
    allMerchants: 'Todos los comercios',
    type: 'Tipo',
    builtIn: 'Integrado',
    nonBuiltIn: 'No integrado',
    appliedMachines: 'Máquinas aplicadas',
    defaultSort: 'Orden',
    serialNo: 'N.º',
    batchCopy: 'Copiar en lote',
    copy: 'Copiar',
    tip: 'Aviso',
    deletePrompt: 'Al eliminar este filtro, las máquinas no podrán usarlo. ¿Confirma que desea eliminarlo?',
    editFilterSuccess: 'Filtro editado correctamente',
    loadCompanyFailed: 'No se pudo cargar la lista de comercios',
    copyFilterSuccess: 'Filtro copiado correctamente',
    copyFilterFailed: 'Error al copiar el filtro',
    batchCopySuccess: 'Filtros copiados correctamente',
    batchCopyFailed: 'Error al copiar filtros en lote',
    selectFilterFirst: 'Seleccione primero los filtros a copiar',
    copyToMerchantTitle: 'Copiar filtro al comercio',
    batchCopyTitle: 'Copiar filtros en lote al comercio',
    originalFilterName: 'Nombre del filtro original',
    newFilterName: 'Nuevo nombre del filtro',
    inputNewFilterName: 'Introduzca el nuevo nombre del filtro',
    targetMerchant: 'Comercio destino',
    selectCompany: 'Seleccione un comercio',
    selectedFilters: 'Filtros seleccionados',
    nameSuffix: 'Sufijo de nombre común',
    inputNameSuffix: 'Introduzca el sufijo de nombre común',
    nameSuffixTip: 'Nuevo nombre = nombre original + este sufijo',
    inputFilterName: 'Introduzca el nombre del filtro',
    inputName: 'Introduzca un nombre',
    selectTypeMsg: 'Seleccione un tipo',
    inputDefaultSort: 'Introduzca el orden',
    colorMatrix: 'Matriz de color',
    whitening: 'Blanqueamiento',
    smoothing: 'Suavizado de piel',
    bigEye: 'Ojos grandes',
    thinFace: 'Rostro delgado',
    smallFace: 'Rostro pequeño',
    forehead: 'Frente',
    cheekbone: 'Pómulos',
    nose: 'Nariz',
    mouth: 'Boca',
    chin: 'Barbilla',
    intensity: 'Intensidad del filtro',
    sampleFullColor: 'Muestra a todo color:',
    colorModeExample: 'Ejemplo del modo a color',
    pngFilterExample: 'Ejemplo PNG original del filtro',
    anyFormatMax10M: 'Cualquier formato, hasta 10 MB',
    colorModeNormal: 'Modo a color - Normal:',
    colorModePressed: 'Modo a color - Presionado:',
    reuseAllSampleColor: 'Reutilizar la muestra a todo color para todas',
    addUploadImage: 'Añadir y subir imagen',
    uploadFile: 'Subir archivo',
    reupload: 'Volver a subir',
    submit: 'Enviar',
    btnNormalRequired: 'La imagen "Modo a color - Normal" no puede estar vacía!',
    imageUrlRequired: 'La imagen de muestra a todo color no puede estar vacía!',
    filterPngRequired: 'La imagen original del filtro no puede estar vacía!',
    btnSelectedRequired: 'La imagen "Modo a color - Presionado" no puede estar vacía!',
    exceed10M: 'Supera el límite de 10 MB, no se permite subir~',
    uploadFailed: 'Error al subir'
  },
  goods: {
    productName: 'Nombre del producto',
    newProductName: 'Nuevo nombre del producto',
    productCode: 'Código del producto',
    preview: 'Vista previa',
    width: 'Ancho',
    height: 'Alto',
    imageCount: 'Número de imágenes',
    frameTop: 'Distancia desde arriba',
    frameBottom: 'Distancia desde abajo',
    frameLeft: 'Distancia desde la izquierda',
    frameRight: 'Distancia desde la derecha',
    frameCount: 'Cantidad de marcos',
    printMode: 'Modo de impresión',
    orientation: 'Dirección de impresión',
    price: 'Precio unitario',
    companyPrice: 'Precio del comerciante',
    increasePrice: 'Precio de impresión adicional',
    defaultIncreasePrice: 'Precio de impresión adicional predeterminado',
    companyIncreasePrice: 'Precio de impresión adicional del comerciante',
    type: 'Tipo',
    deviceCount: 'Número de máquinas aplicadas',
    operation: 'Operación',
    tip: 'Consejo',
    confirmDelete: 'Después de eliminarlo, las máquinas no podrán seleccionar este producto. ¿Está seguro de eliminarlo?',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Eliminar',
    search: 'Buscar',
    addProduct: '+ Agregar producto',
    pleaseInputContent: 'Por favor ingrese el contenido de búsqueda',
    sequenceNumber: 'Nº',
    printingMode: 'Modo de impresión',
    oneCopyInDuplicate: 'Una copia',
    inDuplicate: 'Modo de impresión',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    riceConfirmation: '¡Por favor ingrese el precio correcto! Solo puede ser mayor o igual a 0.01',
    cannotEditBuiltIn: 'Los productos integrados no se pueden editar, solo el superadministrador puede editarlos',
    cannotDeleteBuiltIn: 'Los productos integrados no se pueden eliminar, solo el superadministrador puede eliminarlos',
    copy: 'Copiar',
    copyProduct: 'Copiar producto',
    originalProductName: 'Nombre del producto original',
    inputProductName: 'Por favor ingrese el nombre del nuevo producto',
    selectCompany: 'Por favor seleccione un comerciante',
    copySuccess: 'Producto copiado exitosamente',
    frameManage: 'Gestión de marcos',
    orderNum: 'Orden',
    belongCategory: 'Categoría',
    belongCompany: 'Comerciante',
    subCategory: 'Subcategoría',
    groupName: 'Nombre del grupo'
  },
  order: {
    orderManagement: 'Gestión de pedidos',
    orderList: 'Lista de pedidos',
    all: 'Todos',
    paid: 'Pagado',
    completed: 'Completado',
    unpaid: 'No pagado',
    refunded: 'Reembolsado',
    timeout: 'Tiempo agotado',
    canceled: 'Cancelado',
    paying: 'Pagando',
    unclose: 'No cerrado',
    closed: 'Cerrado',
    toBeReversed: 'Por revertir',
    reversed: 'Revertido',
    evaluated: 'Evaluado',
    exception: 'Excepción',
    unknown: 'Desconocido',
    payFail: 'Pago fallido',
    notRefund: 'N/A',
    applyRefund: 'Solicitar reembolso',
    refundInProgress: 'Reembolso en proceso',
    agreeRefund: 'Aceptar reembolso',
    refuseRefund: 'Rechazar reembolso',
    refundedStatus: 'Reembolso completado',
    refundFail: 'Reembolso fallido',
    cancelRefund: 'Cancelar reembolso',
    photo: 'Foto',
    print: 'Imprimir',
    remotePrint: 'Impresi\u00f3n remota',
    viewRemotePhotos: 'Ver fotos',
    remotePrintPhotos: 'Fotos de impresi\u00f3n remota',
    uploadPhotos: 'Fotos subidas',
    uploadPrint: 'Subir e imprimir',
    noPhotos: 'Sin fotos',
    orderNumber: 'Número de pedido',
    merchant: 'Comerciante correspondiente',
    deviceNumber: 'Número de máquina',
    payMode: 'M\u00eda de pago',
    orderType: 'Tipo de pedido',
    paymentStatus: 'Estado de pago',
    totalPrice: 'Precio total',
    createTime: 'Fecha de creación',
    payTime: 'Fecha de pago',
    quantity: 'Cantidad',
    unitPrice: 'Precio unitario',
    discountAmount: 'Monto de descuento',
    refundStatus: 'Estado de reembolso',
    refundReason: 'Nota del pedido',
    operation: 'Operación',
    export: 'Exportar',
    orderCount: 'Número de pedidos',
    searchPlaceholder: 'Por favor ingrese el contenido de búsqueda',
    agree: 'Aceptar reembolso',
    refuse: 'Rechazar reembolso',
    refund: 'Reembolso',
    viewPhoto: 'Ver fotos',
    gifImage: 'GIF animado',
    confirmAgreeRefund: '¿Aceptar la solicitud de reembolso de este pedido?',
    agreeRefundContent: 'Después de hacer clic en Aceptar, este pedido completará la solicitud de reembolso',
    agreeRefundSuccess: 'Solicitud de reembolso aceptada exitosamente',
    confirmRefuseRefund: '¿Rechazar la solicitud de reembolso de este pedido?',
    refuseRefundContent: 'Después de hacer clic en Aceptar, este pedido rechazará la solicitud de reembolso',
    refuseRefundSuccess: 'Solicitud de reembolso rechazada exitosamente',
    deviceName: 'Nombre de la máquina',
    viewPhotos: 'Detalles de fotos',
    photoDetail: 'Detalles de fotos',
    compositePhotos: 'Fotos compuestas',
    originalPhotos: 'Fotos originales',
    noCompositePhotos: 'No hay fotos compuestas',
    noOriginalPhotos: 'No hay fotos originales',
    frameId: 'ID del marco',
    copyOrderCode: 'Copiar código del pedido',
    allMerchants: 'Todos los comercios',
    allDevices: 'Todos los dispositivos',
    allPayModes: 'Todos los métodos de pago',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Moneda',
    payFree: 'Gratis',
    payCoupon: 'Código de canje',
    payDai: 'Ficha',
    payCoin: 'Pago con moneda',
    payCash: 'Efectivo',
    payCard: 'Tarjeta',
    copySuccess: 'Copiado con éxito',
    copyFail: 'Error al copiar'
  },
  coupon: {
    all: 'Todos',
    notActivated: 'No activado',
    activated: 'Activado',
    used: 'Usado',
    cancelled: 'Cancelado',
    searchPlaceholder: 'Por favor ingrese el código del cupón/nombre del comerciante/nombre del dispositivo',
    export: 'Exportar',
    generateCoupon: 'Generar cupón',
    qrCode: 'Código QR',
    noQrCode: 'Ninguno',
    clickToPreview: 'Haga clic para ver la vista previa',
    couponQrCode: 'Código QR del cupón',
    clickToDownload: 'Haga clic en la imagen para descargar directamente',
    confirmCouponInfo: 'Por favor confirme la información del cupón',
    merchantName: 'Nombre del comerciante',
    selectMerchant: 'Por favor seleccione el nombre del comerciante',
    deviceObject: 'Objeto del dispositivo',
    selectDeviceFirst: 'Por favor seleccione el dispositivo primero',
    couponQuantity: 'Cantidad de cupones',
    inputCouponQuantity: 'Por favor ingrese la cantidad de cupones',
    activateCoupon: '¿Activar cupón?',
    yes: 'Sí',
    no: 'No',
    activate: 'Activar',
    cancel: 'Cancelar',
    couponId: 'Número de cupón',
    merchant: 'Nombre del comerciante',
    deviceName: 'Nombre del dispositivo',
    couponCode: 'Código de cupón',
    status: 'Estado',
    createTime: 'Fecha de generación',
    operation: 'Operación',
    activateSuccess: '¡Activado exitosamente!',
    activateFailed: '¡Error al activar!',
    cancelSuccess: '¡Cancelado exitosamente!',
    cancelFailed: '¡Error al cancelar!',
    generateSuccess: '¡Generado exitosamente!',
    generateFailed: '¡Error al generar!',
    generating: 'Generando cupones, por favor espere...',
    maxCouponLimit: '¡No se pueden generar más de 500 cupones a la vez!',
    generateTip: 'Se pueden generar hasta 500 cupones por vez. Si necesita más, por favor genere en lotes. Cada máquina puede generar hasta 2000 cupones al mes.',
    selectMerchantFirst: '¡Por favor seleccione un comerciante primero!',
    downloadSuccess: '¡Descargado exitosamente!'
  },
  dashboard: {
    date: 'Fecha',
    flow: 'Número de clientes',
    companyCount: 'Número de nuevos comerciantes',
    deviceCount: 'Número de nuevas máquinas',
    photoCount: 'Número de pedidos de fotos',
    printCount: 'Número de pedidos de impresión',
    amount: 'Ingresos totales de la plataforma',
    justSumAmount: 'Comisión de la plataforma',
    companySumAmount: 'Comisión del comerciante',
    lineCount: 'Número de máquinas en línea',
    companyName: 'Nombre del comerciante',
    deviceCode: 'Código de la máquina',
    activeCode: 'Código de la máquina',
    deviceName: 'Nombre de la máquina',
    photo: 'Número de pedidos de fotos',
    print: 'Número de pedidos de impresión',
    totalPrice: 'Ingresos totales de la plataforma',
    timeCycle: 'Tiempo',
    defaultTimeFilter: 'Filtro de tiempo predeterminado (mes)',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    search: 'Buscar',
    export: 'Exportar',
    refund: 'Reembolso',
    confirmRefund: '¿Solicitar reembolso para este pedido?',
    refundContent: 'Después de hacer clic en Aceptar, este pedido iniciará una solicitud de reembolso',
    refundSuccess: 'Solicitud de reembolso del pedido exitosa',
    confirmAgreeRefund: '¿Aceptar la solicitud de reembolso de este pedido?',
    agreeRefundContent: 'Después de hacer clic en Aceptar, este pedido completará la solicitud de reembolso',
    agreeRefundSuccess: 'Solicitud de reembolso aceptada exitosamente',
    confirmRefuseRefund: '¿Rechazar la solicitud de reembolso de este pedido?',
    refuseRefundContent: 'Después de hacer clic en Aceptar, este pedido rechazará la solicitud de reembolso',
    refuseRefundSuccess: 'Solicitud de reembolso rechazada exitosamente',
    timeRangeRequired: 'El rango de tiempo no puede estar vacío'
  },
  uiGroup: {
    uiGroupManage: 'Gestión de grupos de UI',
    newUIGroup: 'Nuevo grupo de UI',
    searchUIName: 'Buscar nombre del grupo de UI...',
    resourceType: 'Tipo de recurso',
    adminDefine: 'Definido por Admin',
    merchantDefine: 'Definido por comerciante',
    uiName: 'Nombre de UI',
    subPageCount: 'Número de subpáginas',
    downloadPackage: 'Descargar paquete',
    onlyOneInCategoryCannotDelete: 'Solo queda un grupo de UI en esta categoría (idioma + producto), no se puede eliminar',
    remark: 'Observación',
    createTime: 'Fecha de creación',
    pageManage: 'Gestión de páginas',
    copy: 'Copiar',
    copyPrompt: '¿Está seguro de copiar este grupo de UI?',
    copySuccess: 'Copiado exitosamente',
    copyFail: 'Error al copiar',
    copyUIGroup: 'Copiar grupo de UI',
    originalUIName: 'Nombre del grupo de UI original',
    newUIName: 'Nuevo nombre del grupo de UI',
    inputNewUIName: 'Por favor ingrese el nuevo nombre del grupo de UI',
    selectCompany: 'Por favor seleccione un comerciante',
    companyName: 'Nombre del comerciante',
    addUIGroup: 'Nuevo grupo de UI',
    deletePrompt: '¿Está seguro de eliminar este grupo de UI?',
    deleteSuccess: 'Eliminado exitosamente',
    editUIGroup: 'Editar grupo de UI',
    editSuccess: 'Editado exitosamente',
    addSuccess: 'Grupo de UI agregado exitosamente',
    addFail: 'Error al agregar grupo de UI',
    newPage: 'Nueva página',
    editPage: 'Editar página',
    addPage: 'Agregar página',
    pageName: 'Nombre de la página',
    pageKey: 'Clave de la página',
    pageOrder: 'Orden de la página',
    elementCount: 'Número de elementos',
    elementManage: 'Gestión de elementos',
    pleaseInputPageName: 'Por favor ingrese el nombre de la página',
    pleaseInputPageKey: 'Por favor ingrese la clave de la página',
    pleaseInputPageOrder: 'Por favor ingrese el orden de la página',
    deletePagePrompt: '¿Está seguro de eliminar esta página? ¡No se puede recuperar después de eliminar!',
    addPageSuccess: 'Página agregada exitosamente',
    addPageFail: 'Error al agregar página',
    editPageSuccess: 'Página editada exitosamente',
    editPageFail: 'Error al editar página',
    deletePageSuccess: 'Página eliminada exitosamente',
    deletePageFail: 'Error al eliminar página',
    pageKeyExists: 'La clave de la página ya existe, por favor cámbiela',
    productType: 'Tipo de producto',
    elementName: 'Nombre del elemento',
    elementType: 'Tipo de elemento',
    allElement: 'Todos los elementos',
    editElement: 'Editar elemento',
    addElement: 'Agregar elemento',
    elementValue: 'Valor del elemento',
    elementValueMsg: 'Por favor ingrese el valor del elemento',
    elementKey: 'Clave del elemento',
    elementKeyMsg: 'Por favor ingrese la clave del elemento',
    elementKeyPlaceholder: 'La clave del elemento no puede duplicarse en la misma página, se recomienda usar letras y guiones bajos',
    elementNameMsg: 'Por favor ingrese el nombre del elemento',
    elementTypeMsg: 'Por favor seleccione el tipo de elemento',
    elementKeyError: 'La clave del elemento ya existe en la página actual, por favor cámbiela',
    elemnetDeleteTips: '¿Está seguro de eliminar este elemento?',
    batchEditElement: 'Edición de elementos por lotes',
    horizontalLayout: 'Diseño horizontal',
    verticalLayout: 'Diseño vertical',
    loadingElementList: 'Cargando lista de elementos...',
    allResourceType: 'Todos los tipos de recursos',
    pleaseInputUIName: 'Por favor ingrese el nombre del grupo de UI',
    pleaseSelectResourceType: 'Por favor seleccione el tipo de recurso',
    previewImage: 'Imagen de vista previa',
    reupload: 'Volver a subir',
    uploadPreviewImage: 'Subir vista previa',
    languageType: 'Idioma',
    selectLanguageType: 'Por favor seleccione el idioma',
    pageSize: 'Tamaño de página',
    pixelWH: 'Píxeles (ancho×alto)',
    belongCompany: 'Comerciante',
    cancelDefaultConfirm: '¿Está seguro de que desea cancelar el estado predeterminado de este grupo de UI?',
    setDefaultConfirm: '¿Está seguro de que desea establecer este grupo de UI como predeterminado?',
    operateSuccess: '¡Operación exitosa!',
    operateFail: 'Operación fallida',
    onlyJpgPng: '¡Solo se pueden subir imágenes JPG y PNG!',
    exceed4M: '¡El tamaño de la imagen no puede exceder 4MB!',
    uploadSuccess: 'Subida exitosa',
    uploadSuccessNoUrl: 'Subida exitosa pero no se pudo obtener la URL de la imagen',
    inputImageUrlPlaceholder: 'O introduce una URL de imagen directamente (http/https)',
    useImageUrl: 'Usar esta URL',
    invalidImageUrl: 'Introduce una URL de imagen válida (que empiece por http:// o https://)',
    imageUrlApplied: 'URL de imagen aplicada',
    pasteTip: 'Consejo: después de copiar una imagen o hacer una captura, pulsa Ctrl+V/Cmd+V para pegarla y subirla',
    pasteUploadSuccess: 'Imagen pegada subida correctamente',
    langZhCN: 'Chino simplificado',
    langEn: 'Inglés',
    langFr: 'Francés',
    langKo: 'Coreano',
    langZhTW: 'Chino tradicional',
    langVi: 'Vietnamita',
    langAr: 'Árabe',
    langBih: 'Bosnio',
    langTh: 'Tailandés',
    langDe: 'Alemán',
    langEs: 'Español'
  },
  deviceSetup: {
    title: 'Configuración del dispositivo',
    basicInfo: 'Información básica',
    machineModelSN: 'Modelo de máquina [SN]',
    inputMachineSN: 'Por favor ingrese el código SN de la máquina',
    machineName: 'Nombre de la máquina',
    inputMachineName: 'Por favor ingrese el nombre de la máquina',
    machineCode: 'Código de la máquina',
    inputMachineCode: 'Por favor ingrese el código de la máquina',
    machineAddress: 'Dirección de la máquina',
    inputMachineAddress: 'Por favor ingrese la dirección de la máquina',
    activationCode: 'Código de activación',
    h5Url: 'URL de la página H5',
    parseUrl: 'Analizar URL',
    urlEditorTitle: 'Gestión de parámetros de URL H5',
    urlBase: 'URL base',
    urlParams: 'Parámetros de URL',
    paramName: 'Nombre del parámetro',
    paramValue: 'Valor del parámetro',
    addParam: 'Añadir parámetro',
    noParams: 'Sin parámetros. Haz clic en "Añadir parámetro"',
    done: 'Hecho',
    pasteTip: 'Consejo: Después de copiar una imagen o hacer una captura, pulsa Ctrl+V para pegarla y subirla',
    pasteUploadSuccess: 'Imagen pegada subida correctamente',
    filterByCompany: 'Filtrar por comercio',
    customerServicePhone: 'Teléfono de atención al cliente',
    photoAccessType: 'Método de acceso a fotos',
    selectPhotoAccessType: 'Por favor seleccione el tipo',
    paymentMode: 'Modo de pago',
    selectPaymentMode: 'Por favor seleccione el tipo',
    onlinePayment: 'Pago en línea',
    offlineCoin: 'Moneda física',
    scanQRCode: 'Escanear código QR',
    addFriend: 'Agregar amigo',
    machineSettings: 'Configuración de la máquina',
    uiGroupSelection: 'Selección de grupo de UI',
    selectUiGroup: 'Por favor seleccione el grupo de UI',
    uiSelection: 'Selección de UI',
    searchUiName: 'Buscar nombre de UI',
    viewAll: 'Todos',
    viewSelected: 'Solo seleccionados',
    builtIn: 'Integrado',
    notBuiltIn: 'No integrado',
    productSelection: 'Selección de productos',
    searchProductName: 'Buscar nombre del producto',
    selectAll: 'Seleccionar todo',
    frameSelection: 'Selección de marcos',
    selectProductFirst: 'Por favor seleccione un producto primero',
    searchFrameName: 'Buscar nombre del marco',
    noProductSelected: 'Por favor seleccione al menos un producto primero, luego seleccione un producto para ver los marcos correspondientes',
    noFrameData: 'No hay datos de marcos para el producto actual',
    filterSelection: 'Selección de filtros',
    searchFilterName: 'Buscar nombre del filtro',
    stickerGroup: 'Grupo de pegatinas',
    searchGroupName: 'Buscar nombre del grupo',
    noStickerGroupData: 'No hay datos de grupos de pegatinas',
    stickersCount: '{count} pegatinas',
    parameterSettings: 'Configuración de parámetros',
    photoTime: 'Tiempo de foto',
    seconds: 'segundos',
    inputPhotoTime: 'Por favor ingrese el tiempo de foto',
    intervalTime: 'Intervalo de tiempo',
    inputIntervalTime: 'Por favor ingrese el intervalo de tiempo',
    paperCount: 'Número de papeles',
    sheets: 'hojas',
    inputPaperCount: 'Por favor ingrese el número de papeles',
    paperCountRequired: 'El número de papeles es obligatorio',
    cancel: 'Cancelar',
    save: 'Guardar',
    selectAtLeastOneProduct: 'Por favor seleccione al menos un producto',
    selectAtLeastOneFilter: 'Por favor seleccione al menos un filtro',
    paperCountMinLimit: 'El número de papeles no puede ser menor a 50',
    serverConnectionError: 'Error de conexión al servidor, ¡intente nuevamente más tarde!',
    deviceThumbnail: 'Miniatura del dispositivo',
    modify: 'Modificar',
    upload: 'Subir',
    remoteDesktopInfo: 'Información de escritorio remoto',
    remoteDesktopPlaceholder: 'Ingrese la información de escritorio remoto (código remoto)',
    format: 'Formatear',
    belongCategory: 'Categoría',
    selectBelongCategory: 'Por favor seleccione la categoría',
    onlyJpgPng: 'Solo se pueden subir imágenes JPG y PNG~',
    exceed4M: 'Excede el límite de 4M, no se permite subir~',
    thumbnailUploadFailed: 'Error al subir la miniatura',
    jsonFormatErrorFormat: 'Formato JSON inválido, no se puede formatear, verifique y reintente',
    jsonFormatError: 'Formato JSON inválido, verifique y reintente',
    showName: 'Nombre para mostrar del dispositivo (Escanee el código QR para descargar el título de la página de fotos electrónicas)',
    showNamePlaceholder: 'Se muestra como título en la página de descarga de fotos electrónicas'
  },
  personal: {
    oldPassword: 'Contraseña antigua',
    inputOldPassword: 'Introduzca la contraseña antigua',
    strength: 'Fuerza: ',
    passwordTip: 'Introduzca al menos 6 caracteres. No use contraseñas fáciles de adivinar.',
    newPassword: 'Nueva contraseña',
    passwordPlaceholder: 'Al menos 6 caracteres, distingue mayúsculas',
    confirmPassword: 'Confirmar de nuevo',
    confirmPasswordPlaceholder: 'Confirmar contraseña',
    levelLow: 'Baja',
    levelMedium: 'Media',
    levelStrong: 'Fuerte',
    minSixChars: 'Introduzca una contraseña de al menos 6 caracteres',
    strengthNotEnough: 'La fuerza de la contraseña no es suficiente',
    inputPassword: 'Introduzca la contraseña',
    passwordNotMatch: 'Las dos contraseñas no coinciden',
    oldPasswordIncorrect: 'La contraseña antigua es incorrecta',
    editProfile: 'Editar perfil',
    updateAvatar: 'Cambiar avatar',
    avatarAlt: 'Avatar',
    avatarUpdateSuccess: 'Avatar actualizado con éxito',
    email: 'Correo',
    mobile: 'Móvil',
    dept: 'Departamento',
    gender: 'Sexo',
    description: 'Descripción',
    inputEmail: 'Introduzca el correo',
    inputMobile: 'Introduzca el número de móvil',
    emailInvalid: 'Introduzca un correo válido',
    emailMax: 'La longitud no puede superar 50 caracteres',
    mobileInvalid: 'Introduzca un número de móvil válido',
    selectGender: 'Seleccione el sexo',
    descMax: 'La longitud no puede superar 100 caracteres',
    submit: 'Enviar',
    selectAvatar: 'Seleccionar avatar',
    clickToSelect: 'Haga clic para seleccionar',
    updatingWarning: 'Actualizando avatar, no haga clic repetidamente',
    updateAvatarFailed: 'No se pudo actualizar el avatar',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Serie Ali',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'Información de usuario',
    account: 'Cuenta: ',
    role: 'Rol: ',
    noRole: 'Sin rol',
    male: 'Masculino',
    female: 'Femenino',
    confidential: 'Confidencial',
    department: 'Departamento: ',
    noDepartment: 'Sin departamento',
    gender: 'Sexo: ',
    phone: 'Teléfono: ',
    noPhone: 'Teléfono no vinculado',
    email: 'Correo: ',
    noEmail: 'Correo no vinculado',
    status: 'Estado: ',
    locked: 'Bloqueado',
    valid: 'Activo',
    createTime: 'Creado: ',
    lastLogin: 'Último acceso: ',
    description: 'Descripción: '
  },
  remotePrint: {
    loading: 'Cargando...',
    expired: 'Registro expirado',
    expiredDesc: 'Este registro de carga ha expirado. Por favor, vuelva al terminal e inténtelo de nuevo.',
    completed: 'Completado',
    completedDesc: 'Las fotos se han enviado correctamente. Espere junto al terminal para la impresión.',
    submitted: 'Enviado',
    submittedDesc: 'Las fotos han sido enviadas al terminal. Complete los pasos siguientes en el dispositivo.',
    orderInfo: 'Info del pedido',
    recordCode: 'Nº de registro',
    orderCode: 'Nº de pedido',
    product: 'Producto',
    price: 'Precio',
    expireTime: 'Expira a las',
    photos: 'Fotos',
    addPhoto: 'Añadir foto',
    tipFormat: 'Solo se admiten imágenes JPG/PNG',
    tipSize: 'Cada foto no debe superar 3MB',
    tipExpire: 'El registro es válido por 5 minutos, suba rápido',
    submit: 'Subir e imprimir',
    submitting: 'Enviando...',
    noRecordCode: 'Falta el código de registro. Escanee el código QR.',
    loadFailed: 'Error al cargar. Inténtelo de nuevo.',
    invalidFormat: 'Solo se admite JPG/PNG',
    photoLimit: 'Se pueden subir hasta {count} fotos',
    fileTooLarge: 'El archivo no puede superar 10MB',
    uploadFailed: 'Error al subir. Inténtelo de nuevo.',
    noPhotoUploaded: 'Suba al menos una foto',
    submitFailed: 'Error al enviar. Inténtelo de nuevo.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/es-ES.js